import { useNavigate } from "react-router-dom";
import { FetchConstatsResponse } from "../../../types/apiResponsesTypes";
import { ConstatPartial } from "../../../types/constats";
import GenericTable from "../GenericTable";
import useTableConstats from "./hooks/useTableConstats";

type Props = {
  data: FetchConstatsResponse | undefined;
  fetchData: (queryParams?: string) => void;
  isLoading: boolean;
  onDelete: (id: number) => void;
};

const TableConstats: React.FC<Props> = ({ data, fetchData, isLoading, onDelete }) => {
  const navigate = useNavigate();
  const { columns, onRowClick } = useTableConstats({ navigate, onDelete });

  return (
    <GenericTable<ConstatPartial>
      results={data?.results || []}
      count={data?.count || 0}
      columns={columns}
      fetchData={fetchData}
      isLoading={isLoading}
      onRow={onRowClick}
    />
  );
};

export default TableConstats;
